import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Conditionals discounts")]), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "subtitle"
  }, [_vm._v("Add/Edit discounts")]), _c("div", {
    staticClass: "search-top-buttons"
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.listWines,
      disabled: _vm.isLoadingWines,
      "item-text": "display_name",
      "item-value": "id_wine",
      label: _vm.isLoadingWines ? "Loading ..." : "Search product name, SKU",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete,
      clearable: "",
      dense: "",
      solo: ""
    },
    on: {
      "click:clear": function clickClear() {
        _vm.currentWineId = null;
      }
    },
    model: {
      value: _vm.currentWineId,
      callback: function callback($$v) {
        _vm.currentWineId = $$v;
      },
      expression: "currentWineId"
    }
  }), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: !_vm.currentWineId
    },
    on: {
      click: function click($event) {
        return _vm.openDiscounts();
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-pen mr-1"
  }), _vm._v(" Edit discounts ")])], 1), _c(VDivider, {
    staticClass: "mb-2"
  }), _c("div", {
    staticClass: "subtitle"
  }, [_vm._v("Existing discounts")]), _c("div", {
    staticClass: "search-multi-line"
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.isLoadingWineries,
      items: _vm.listWineries,
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      "item-text": "name",
      "item-value": "id",
      label: "Select producers",
      placeholder: "Type a producer name",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete,
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      },
      "click:clear": function clickClear($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.list_id_wineries,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "list_id_wineries", $$v);
      },
      expression: "formSearch.list_id_wineries"
    }
  })], 1), _c("div", [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.isLoadingWines,
      items: _vm.listWines,
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      "item-text": "display_name",
      "item-value": "id_wine",
      label: "Select products",
      placeholder: "Type a product name, vintage or producer",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete,
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      },
      "click:clear": function clickClear($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.list_id_wines,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "list_id_wines", $$v);
      },
      expression: "formSearch.list_id_wines"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit push-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      "hide-details": "auto",
      items: _vm.defaultPagingChoices
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.formSearch.paging.currentPage,
      limits: +_vm.formSearch.paging.limits,
      totalNumber: _vm.conditionalDiscountCount
    }
  })], 1)]), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --no-hover",
    attrs: {
      headers: _vm.headers,
      items: _vm.items,
      "items-per-page": +_vm.formSearch.paging.limits,
      loading: _vm.isLoadingList,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.action",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [_c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click() {
              _vm.currentWineId = item.id_wine;
              _vm.openDiscounts();
            }
          }
        }, [_vm._v(" Edit ")])])];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("Paging", {
    attrs: {
      numberOfPages: _vm.numberOfPages,
      currentPage: +_vm.formSearch.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.defaultPagingChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: _vm.search
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.formSearch.paging.currentPage,
      limits: +_vm.formSearch.paging.limits,
      totalNumber: _vm.conditionalDiscountCount
    }
  })], 1)])]) : _vm._e()], 1), _vm.isConditionalDiscountModalShown && false ? _c("ConditionalDiscountModal", {
    ref: "ConditionalDiscountModal",
    attrs: {
      wineId: _vm.currentWineId
    },
    on: {
      closed: _vm.closeDiscounts
    }
  }) : _vm._e(), _vm.isConditionalDiscountModalShown ? _c("ConditionalDiscountV2Modal", {
    ref: "ConditionalDiscountV2Modal",
    attrs: {
      wineId: _vm.currentWineId
    },
    on: {
      closed: _vm.closeDiscounts
    }
  }) : _vm._e(), _c("confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };